import axios from 'axios';
import config from './index';

let serverType: 'production' | 'develop' = 'develop';

const base = {
  production: {
    gateway: axios.create({
      baseURL: config.REACT_APP_API_GATEWAY_URL,
      timeout: 15000,
      validateStatus: () => true,
    }),
  },
  develop: {
    gateway: axios.create({
      baseURL: config.REACT_APP_API_GATEWAY_URL,
      timeout: 15000,
      validateStatus: () => true,
    }),
  },
};

const gateway = () => base[serverType].gateway;

export const switchServer = (type: 'production' | 'develop') => {
  serverType = type;
};

export {gateway};
